import { useEffect, useState } from "react";
import { LuUserPlus } from "react-icons/lu";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../contexts/list.manager";
import FormInvitation from "../FormInvitation/FormInvitation";
import ListInvitation from "../ListInvitations/ListInvitation";
import "./ConsultaInvitations.css";

const ConsultaInvitations = () => {
	const { lineSelected } = useListManager();
	const [search, setSearch] = useState("");
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					title="Convites"
					icon={<LuUserPlus size={20} />}
					navigate="../cadastro-invitations"
					buttonLabel="Adicionar Convite"
				>
					<SearchInput
						value={search}
						placeholder="Buscar por Convite"
						onChange={({ target }) => setSearch(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(search)}
					/>
				</SearchContainer>
				<Container>
					<ListInvitation filters={filters} refreshKey={refreshKey} />
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormInvitation invitation={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaInvitations;
